import { NgModule } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';
import { EditWorkspaceComponent } from './components/edit-workspace/edit-workspace.component';
import { WorkspaceRoutingModule } from './workspace.route';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from '../sub-modules/SharedModule';
import { CreateWorkspaceComponent } from './components/create-workspace/create-workspace.component';
import { EditWorkspacePermissionsComponent } from './components/edit-workspace/workspace-permissions/workspace-permissions.component';
import { NewWorkspaceUserComponent } from './components/edit-workspace/new-user/new-workspace-user.component';
import { WorkspaceProjectsComponent } from './components/edit-workspace/workspace-projects/workspace-projects.component';
import { ProjectModalsModule } from '../sub-modules/project-modals/project-modals.module';
import { WorkspaceCreationGuard } from './guards/workspace-creation.guard';
import { WorkspaceProjectParticipantTableModule } from './components/edit-workspace/workspace-projects/table/workspace-project-participant-table.module';
import { AgGridModule } from 'ag-grid-angular';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccountPageComponent } from '@mtm/permission-ui';
import { WorkspaceGeneralInfoComponent } from './components/edit-workspace/workspace-general-info/workspace-general-info.component';

@NgModule({
  declarations: [
    CreateWorkspaceComponent,
    EditWorkspaceComponent,
    EditWorkspacePermissionsComponent,
    NewWorkspaceUserComponent,
    WorkspaceProjectsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    WorkspaceRoutingModule,
    ProjectModalsModule,
    AgGridModule,
    NgbModule,
    WorkspaceProjectParticipantTableModule,
    NgSelectModule,
    NgOptimizedImage,
    AccountPageComponent,
    WorkspaceGeneralInfoComponent,
  ],
  exports: [],
  providers: [AuthService, WorkspaceCreationGuard, NgbActiveModal],
})
export class WorkspaceModule {}
